import React, { useEffect, useState } from 'react';
import { Card } from 'reactstrap';

import { styles } from './styles';

import './styled.css';

import { statusColors } from '../../../utils/state_colors';

import './styled.css';

const QueueMemberOfflineCard = ({ data, id }) => {
  return (
    <>
      <Card
        style={{
          ...styles.container,
          backgroundColor: `${statusColors.OFFLINE}`
        }}
        id={'tooltip' + id}
      >
        <p style={styles.items}>
          <i className="fas fa-user"></i>
          <span className="mx-1">{data && data?.name}</span>
        </p>
        <p style={styles.items}>
        <i class="fas fa-ban"></i>
        <span className="mx-1">Offline</span>
        </p>
      </Card>
    </>
  );
};

export default QueueMemberOfflineCard;
